// Package Imports
import { toJS } from "mobx";

// Project Imports
import axios from "utils/axios";
import * as APITypes from "constants/API"
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import ChooseNeedsStore from "modules/choose-needs/store/ChooseNeedsStore";
import fetchSalutationMaster from "utils/fetchSalutationMaster"
import AuthStore from "modules/login/store/AuthStore";
import chooseNeedInitialDropdownValues from "./chooseNeedDropDownInitialConstant";
import NeedTypeEnum from "constants/NeedTypeEnum";
import { INDIVIDUAL } from "constants/ CustomerType";
import INCOME_TYPE_ENUM from "constants/incomeTypeEnum";
import utils from "./utils";
import StorageKeys from "constants/StorageKeys";
import { BANCA_JOURNEY, SAMS_JOURNEY } from "constants/Constants";
import getSpDetailsForSams from "utils/getSpDetailsForSams";


const fetchNeedMaster = async () => {
    const needResponse = await axios.get(APITypes.NEED_MASTER)

    if (needResponse.data && needResponse.status == 'success') {
        return needResponse.data
    }
    return []
}

const fetchMastersData = async () => {
    const occupationRequest = axios.get(APITypes.OCCUPATION_MASTER);
    const educationRequest = axios.get(APITypes.EDUCATION_MASTER);
    const categoryRequest = axios.get(APITypes.CATEGORY_MASTER);
    const journeyTypeRequest = axios.get(APITypes.JOURNEY_MASTER);

    return axios.all([occupationRequest, educationRequest, categoryRequest, journeyTypeRequest]).then(
        axios.spread((...responses) => {
            return {
                occupationResponse: responses[0],
                educationResponse: responses[1],
                categoryResponse: responses[2],
                journeyTypeResponse: responses[3],
            };
        })
    );
};

const prefillMasterData = (formController, fetchmasterData) => {

    let { occupationResponse, educationResponse, categoryResponse, journeyTypeResponse } = fetchmasterData;

    let selectedEducation1 = educationResponse.data.find((item) => item.label == "Graduate");

    let selectedOccupation1 = occupationResponse.data.find((item) => item.label === "Salaried");
    formController.$("protection_for_my_family.occupation").set("extra", {
        ...formController.$("protection_for_my_family.occupation").extra,
        optionList: occupationResponse.data,
    });

    formController.$("protection_for_my_family.education").set("extra", {
        ...formController.$("protection_for_my_family.education").extra,
        optionList: educationResponse.data,
    });

    let { family_details_list } = toJS(AuthStore.journeyData)
    let selfFamilyMember = family_details_list?.find((family_member) => (family_member.family_member_type = "SELF"));

    if (selfFamilyMember !== undefined) {
        let selectedEducation = educationResponse.data.find((item) => item.id === selfFamilyMember.education);
        let selectedOccupation = occupationResponse.data.find((item) => item.id === selfFamilyMember.occupation);

        let pinCodeValue = [
            {
                id: selfFamilyMember.pin_code,
                label: selfFamilyMember.office_name,
                location: selfFamilyMember.state,
            },
        ];

        if (selfFamilyMember.education) {
            formController.$("protection_for_my_family.education").value = selectedEducation;
        } else {
            formController.$("protection_for_my_family.education").value = selectedEducation1;
        }

        if (selfFamilyMember.occupation) {
            formController.$("protection_for_my_family.occupation").value = selectedOccupation;
        } else {
            formController.$("protection_for_my_family.occupation").value = selectedOccupation1;
        }

        if (selfFamilyMember.pin_code) {
            formController.$("protection_for_my_family.location").value = pinCodeValue;

            formController.$("protection_for_my_family.location").set("extra", {
                optionList: pinCodeValue,
            });
        }
    } else {
        if (selectedEducation1 !== undefined) {
            formController.$("protection_for_my_family.education").value = selectedEducation1;
        }

        if (selectedOccupation1 !== undefined) {
            formController.$("protection_for_my_family.occupation").value = selectedOccupation1;
        }
    }
};



const preFillFormField = async (formController, need_name, dataObj) => {

    let needDetails = toJS(AuthStore.journeyData.family_details_list).find((item) => item.family_member_type.toLowerCase() === 'self')?.family_product_details_list
    let selectedNeedData = needDetails?.find((item) => item.need_unique_name === need_name)
    if (dataObj === undefined) {
        formController.$(need_name).set("disabled", true)
        return
    }
    if (selectedNeedData === undefined) return


    let targetAmount = selectedNeedData?.target_amount
    let targetAmountValue = selectedNeedData?.target_amount_value
    let isCalculatorUsed = selectedNeedData?.is_calculator_used
    let payoutMode = selectedNeedData?.payout_mode
    let disabled = !dataObj?.is_selected
    let hasTargetAmountField = formController.$(need_name).has('target_amount_value')
    let hasCalculatorField = formController.$(need_name).has('calculator_used')

    let selectedPayoutMode = {}
    let selectedtargetAmount = {}
    let optionList = []
    // let patout_mode = selectedNeedData?.payout_mode === "recommended_lumpsum" ? "lumpsum" : selectedNeedData?.payout_mode
    let productList = formController.$(need_name).$("products_list").extra.preDefinedOptList
    let filterProductList = productList.filter(item =>
        need_name === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY
            ? item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase()
            : item.payout_type.toLowerCase() === payoutMode?.toLowerCase()
    );
    let selectedProduct = filterProductList.filter(item => item.package_id === dataObj?.package_id)

    // let productsList = await utils.getProductList(selectedNeedData.need, patout_mode)
    formController.$(need_name).$("products_list").set("extra", {
        ...formController.$(need_name).$("products_list").extra,
        optionList: filterProductList ? filterProductList : []
    })
    formController.$(need_name).$("products_list").set("value", selectedProduct[0] ? selectedProduct[0] : [])

    if (payoutMode !== undefined && payoutMode !== null) {
        optionList = formController.$(need_name).$("target_amount_type").extra.optionList
        selectedPayoutMode = optionList.find((item) => item.mode.toLowerCase() == payoutMode)

        if (selectedPayoutMode !== undefined) {
            formController.$(need_name).$("target_amount_type").value = selectedPayoutMode
        }
    }

    if (targetAmount !== undefined && targetAmount !== null) {
        optionList = formController.$(need_name).$("target_amount_dropdown").extra.allOptionsList
        selectedtargetAmount = optionList.find((item) => item.id == targetAmount)
        if (selectedtargetAmount !== undefined) {
            formController.$(need_name).$("target_amount_dropdown").value = selectedtargetAmount
        }
    }

    if (!checkIsValueEmpty(targetAmountValue) && hasTargetAmountField && isCalculatorUsed) {
        formController.$(need_name).$("target_amount_value").value = targetAmountValue
        formController.$(need_name).$("target_amount_value").set("type", "text")
        formController.$(need_name).$("target_amount_dropdown").set("type", "hidden")
    }

    if (!checkIsValueEmpty(targetAmountValue) && hasTargetAmountField && (need_name === NeedTypeEnum.GROW_MY_MONEY || need_name === NeedTypeEnum.SAVE_FOR_CHILDREN)) {
        formController.$(need_name).$("target_amount_value").value = targetAmountValue
    }

    if (hasCalculatorField) {
        formController.$(need_name).$("calculator_used").value = isCalculatorUsed
    }
    formController.$(need_name).set("disabled", disabled)

    ChooseNeedsStore.previouslySelectedNeedObject = {
        ...ChooseNeedsStore.previouslySelectedNeedObject,
        [need_name]: { target_amount_type: selectedPayoutMode, selectedtargetAmount: selectedtargetAmount }
    }
}

const preFillFormData = (formController, journeyData) => {
    let needDetails = journeyData.journey_need

    let familyDetails = journeyData.family_details_list;

    if (familyDetails === undefined) return
    let selfDetails = familyDetails.find((item) => item.family_member_type.toLowerCase() == 'self');
    if (selfDetails?.monthly_income !== undefined) {
        formController.$("protection_for_my_family.monthly_income").value = selfDetails.monthly_income
    }

    if (selfDetails?.dob !== undefined) {
        formController.$("protection_for_my_family.dob").value = selfDetails.dob
    }

    if (needDetails === undefined || needDetails.length <= 0) {
        return
    }

    let familyProtectionId = formController.$("protection_for_my_family.id").value
    let healthProtectionId = formController.$("protection_for_my_health.id").value
    let moneyGrowId = formController.$("grow_my_money.id").value
    let saveChildrenId = formController.$("save_for_children.id").value
    let saveRetirementId = formController.$("save_for_retirement.id").value

    let familyProtectionObj = needDetails.find(item => item.need == familyProtectionId)
    let healthProtectionObj = needDetails.find(item => item.need == healthProtectionId)
    let moneyGrowObj = needDetails.find(item => item.need == moneyGrowId)
    let saveChildredObj = needDetails.find(item => item.need == saveChildrenId)
    let saveRetirementObj = needDetails.find(item => item.need == saveRetirementId)

    preFillFormField(formController, 'protection_for_my_family', familyProtectionObj)
    // preFillFormField(formController, 'protection_for_my_health', healthProtectionObj)
    preFillFormField(formController, 'grow_my_money', moneyGrowObj)
    preFillFormField(formController, 'save_for_children', saveChildredObj)
    preFillFormField(formController, 'save_for_retirement', saveRetirementObj)

}

const initialDefaults = async (formController, journeyId, journeyData) => {

    let masterData = await fetchNeedMaster()
    let fetchmasterData = await fetchMastersData()
    let salutation = await fetchSalutationMaster()
    ChooseNeedsStore.setSalutationList(salutation)

    prefillMasterData(formController, fetchmasterData, journeyData);

    if (masterData.length <= 0) return

    let growMyMoney = masterData.find((item) => item.unique_name === 'grow_my_money')

    let saveForChildren = masterData.find((item) => item.unique_name === 'save_for_children')

    let saveForRetirement = masterData.find((item) => item.unique_name === 'save_for_retirement')

    let protectionForMyFamily = masterData.find((item) => item.unique_name === 'protection_for_my_family')

    let protectionForMyHealth = masterData.find((item) => item.unique_name === 'protection_for_my_health')

    formController.$("journey_id").value = journeyId

    const urlParams = new URLSearchParams(location?.search);
    const source_system = urlParams.get("source");
    if (source_system === BANCA_JOURNEY || source_system === SAMS_JOURNEY) {
        await getSpDetailsForSams()
    }
    let allProductListData = await utils.prefillProductsList()
    let isUlipUser = localStorage.getItem(StorageKeys.ULIP_TRAINING) === "1"
    formController.$("protection_for_my_family.products_list").set("extra", {
        ...formController.$("protection_for_my_family.products_list").extra,
        preDefinedOptList: allProductListData ? allProductListData[NeedTypeEnum.PROTECTION_FOR_MY_FAMILY] : []
    })

    formController.$("protection_for_my_health.products_list").set("extra", {
        ...formController.$("protection_for_my_health.products_list").extra,
        preDefinedOptList: allProductListData ? allProductListData[NeedTypeEnum.PROTECTION_FOR_MY_HEALTH] : []
    })

    formController.$("grow_my_money.products_list").set("extra", {
        ...formController.$("grow_my_money.products_list").extra,
        preDefinedOptList: allProductListData ? utils.filterProductlist(isUlipUser, allProductListData[NeedTypeEnum.GROW_MY_MONEY]) : []
    })
    formController.$("save_for_children.products_list").set("extra", {
        ...formController.$("save_for_children.products_list").extra,
        preDefinedOptList: allProductListData ? utils.filterProductlist(isUlipUser, allProductListData[NeedTypeEnum.SAVE_FOR_CHILDREN]) : []
    })
    formController.$("save_for_retirement.products_list").set("extra", {
        ...formController.$("save_for_retirement.products_list").extra,
        preDefinedOptList: allProductListData ? utils.filterProductlist(isUlipUser, allProductListData[NeedTypeEnum.SAVE_FOR_RETIREMENT]) : []
    })

    /* ! protection for my family target amount type dropdown data */


    formController.$("protection_for_my_family.target_amount_type").set("extra", {
        ...formController.$("protection_for_my_family.target_amount_type").extra,
        optionList: protectionForMyFamily.mode_master
    })

    /* ! protection for my family target amount type dropdown default value */

    formController.$("protection_for_my_family.target_amount_type").value = protectionForMyFamily.mode_master[0]

    if (journeyId === null) {
        let payout_mode = protectionForMyFamily?.mode_master[1]?.mode.toLowerCase()

        let productList = formController.$("protection_for_my_family.products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item?.payout_type.toLowerCase() === payout_mode)
        // let productsList = await utils.getProductList(protectionForMyFamily?.id, payout_mode)
        formController.$("protection_for_my_family.products_list").set("extra", {
            ...formController.$("protection_for_my_family.products_list").extra,
            optionList: filterProductList ? filterProductList : []
        })
        // formController.$("protection_for_my_family.products_list").set("value", filterProductList[0] ? filterProductList[0] : [])
    }

    formController.$("protection_for_my_family.target_amount_dropdown").set("extra", {
        ...formController.$("protection_for_my_family.target_amount_dropdown").extra,
        allOptionsList: protectionForMyFamily.target_amount
    })

    formController.$("protection_for_my_family.id").value = protectionForMyFamily.id

    formController.$("protection_for_my_health.target_amount_dropdown").set("extra", {
        ...formController.$("protection_for_my_health.target_amount_dropdown").extra,
        allOptionsList: protectionForMyHealth.target_amount,
        optionList: protectionForMyHealth.target_amount,
    })

    formController.$("protection_for_my_health.target_amount_dropdown").value = protectionForMyHealth.target_amount.find(item => item.label === chooseNeedInitialDropdownValues.protectionForHealthLumpsum)


    formController.$("protection_for_my_health.id").value = protectionForMyHealth.id

    /* ! grow my money target amount type dropdown data */

    formController.$("grow_my_money.target_amount_type").set("extra", {
        ...formController.$("grow_my_money.target_amount_type").extra,
        optionList: growMyMoney.mode_master
    })


    if (journeyId === null) {
        let payout_mode = growMyMoney?.mode_master[1]?.mode.toLowerCase()
        let productList = formController.$("grow_my_money.products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item?.payout_type.toLowerCase() === payout_mode)
        // let productsList = await utils.getProductList(growMyMoney?.id, payout_mode)
        formController.$("grow_my_money.products_list").set("extra", {
            ...formController.$("grow_my_money.products_list").extra,
            optionList: filterProductList
        })
        // formController.$("grow_my_money.products_list").set("value", filterProductList[0] ? filterProductList[0] : [])
    }


    formController.$("grow_my_money.target_amount_dropdown").set("extra", {
        ...formController.$("grow_my_money.target_amount_dropdown").extra,
        allOptionsList: growMyMoney.target_amount
    })

    formController.$("grow_my_money.target_amount_type").value = formController.$("grow_my_money.target_amount_type").extra.optionList[1]

    formController.$("grow_my_money.target_amount_dropdown").value = growMyMoney.target_amount.find(item => item.label === chooseNeedInitialDropdownValues.growMyMoneyIncome)

    formController.$("grow_my_money.id").value = growMyMoney.id

    formController.$("save_for_children.target_amount_dropdown").set("extra", {
        ...formController.$("save_for_children.target_amount_dropdown").extra,
        allOptionsList: saveForChildren.target_amount
    })

    /* ! save for children target amount type dropdown data */

    formController.$("save_for_children.target_amount_type").set("extra", {
        ...formController.$("save_for_children.target_amount_type").extra,
        optionList: saveForChildren.mode_master
    })

    if (journeyId === null) {
        let payout_mode = saveForChildren?.mode_master[1]?.mode.toLowerCase()

        let productList = formController.$("save_for_children.products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item?.payout_type.toLowerCase() === payout_mode)
        // let productsList = await utils.getProductList(saveForChildren?.id, payout_mode)
        formController.$("save_for_children.products_list").set("extra", {
            ...formController.$("save_for_children.products_list").extra,
            optionList: filterProductList ? filterProductList : []
        })
        // formController.$("save_for_children.products_list").set("value", filterProductList[0] ? filterProductList[0] : [])
    }

    formController.$("save_for_children.target_amount_type").value = formController.$("save_for_children.target_amount_type").extra.optionList[1]

    formController.$("save_for_children.target_amount_dropdown").value = saveForChildren.target_amount.find(item => item.label === chooseNeedInitialDropdownValues.saveForChildrenIncome)

    formController.$("save_for_children.id").value = saveForChildren.id

    /* ! save for retirement target amount type dropdown data */

    formController.$("save_for_retirement.target_amount_type").set("extra", {
        ...formController.$("save_for_retirement.target_amount_type").extra,
        optionList: saveForRetirement.mode_master
    })

    if (journeyId === null) {
        let payout_mode = saveForRetirement?.mode_master[1]?.mode.toLowerCase()

        let productList = formController.$("save_for_retirement.products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item?.payout_type.toLowerCase() === payout_mode)
        // let productsList = await utils.getProductList(saveForRetirement?.id, payout_mode)
        formController.$("save_for_retirement.products_list").set("extra", {
            ...formController.$("save_for_retirement.products_list").extra,
            optionList: filterProductList ? filterProductList : []
        })
        // formController.$("save_for_retirement.products_list").set("value", filterProductList[0] ? filterProductList[0] : [])
    }

    /* ! protection for my family target amount type dropdown default value */
    formController.$("save_for_retirement.target_amount_type").value = saveForRetirement.mode_master[1]

    formController.$("save_for_retirement.target_amount_dropdown").value = saveForRetirement.target_amount.find(item => item.label === chooseNeedInitialDropdownValues.saveForRetirementIncome)

    formController.$("save_for_retirement.target_amount_dropdown").set("extra", {
        ...formController.$("save_for_retirement.target_amount_dropdown").extra,
        allOptionsList: saveForRetirement.target_amount,
        optionList: saveForRetirement.target_amount
    })

    formController.$("save_for_retirement.id").value = saveForRetirement.id

    preFillFormData(formController, journeyData)

}

export default initialDefaults 